import './styles/main.scss';
import './scripts/core/main.ts';